import { cn } from "@core/utils/domUtil";
import type { ReactNode, JSX } from "react";

interface ITitleProps {
  level: number;
  className?: string;
  children: ReactNode;
}

const variants = {
  h1: {
    comp: "h1",
    cls: "text-[36px] font-bold text-gray-800",
  },
  h2: {
    comp: "h2",
    cls: "lg:text-[24px] text-lg font-bold text-gray-800",
  },
  h3: {
    comp: "h3",
    cls: "lg:text-[20px] text-lg font-bold text-gray-800",
  },
  h4: {
    comp: "h4",
    cls: "text-md lg:text-[18px] font-bold text-gray-800",
  },
  h5: {
    comp: "h5",
    cls: "text-md lg:text-lg font-bold text-gray-800",
  },
};

export default function Heading({ level, className, children }: ITitleProps) {
  const { comp, cls } = variants[`h${level}` as keyof typeof variants];
  const Component = comp as keyof JSX.IntrinsicElements;
  return <Component className={cn(cls, className)}>{children}</Component>;
}
